<script setup lang="ts">
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import Updater from '@/utils/updater.js'
import { ElMessageBox } from 'element-plus';


const up = new Updater({
    timer: 10000,
});
//未更新通知
up.on("no-update", () => {

});
//更新通知
up.on("update", () => {
    ElMessageBox.close()
    ElMessageBox.confirm('后台系统已更新请刷新当前页面', '提示', {
      confirmButtonText: '确定',
      showClose: false,
      showCancelButton: false,
      closeOnClickModal: false,
      closeOnPressEscape: false,
      type: 'warning'
    }).then(() => {
        window.location.reload()
    }).catch(() => {})
});


</script>

<template>
    <el-config-provider :locale="zhCn">
        <router-view></router-view>
    </el-config-provider>
</template>

<style lang="less">
@import './styles/index.less';
</style>
